import type { CurrentClientUserClientApiData } from '@client/entity/current-client-user/data/api-data/current-client-user.api-data';
import { CurrentClientUserClient } from '@client/entity/current-client-user/domain/model/current-client-user-client.model';
import type { ApiDataTransformer } from '@kiplin/web-common/architecture-core';
import { format, isValid, parseISO } from 'date-fns';
import { injectable } from 'inversify';

@injectable()
export class CurrentClientUserClientApiDataTransformer implements ApiDataTransformer<
  CurrentClientUserClientApiData,
  CurrentClientUserClient
> {
  map(data: CurrentClientUserClientApiData): CurrentClientUserClient {
    return new CurrentClientUserClient(
      data.id,
      data.name,
      data.accessCode,
      data.logo,
      [],
      data.hasActiveSubscription,
      this.normalizeDate(data.subscriptionStartDate),
      this.normalizeDate(data.subscriptionEndDate),
    );
  }

  private normalizeDate(value?: string | null): string | null {
    if (!value) {
      return null;
    }

    const parsed = parseISO(value);
    if (!isValid(parsed)) {
      return null;
    }

    return format(parsed, 'yyyy-MM-dd');
  }
}
